/**
 * Total width of the S-curve on each side of the active tab (in pixels).
 *
 * @description
 * The curve extends `$curve-width` (SCSS) outside the tab plus the remainder
 * inside the tab body. Larger values produce a wider, gentler S-curve.
 * This value matches the Figma Union border-radius design spec.
 */
export const CURVE_WIDTH = 48

/**
 * Normalized S-curve bezier control points extracted from the Figma Union SVG.
 *
 * @description
 * Each side uses 3 cubic bezier segments forming one continuous S-curve
 * from tab-top (y=0) to content-level (y=1). Coordinates are fractions (0-1)
 * relative to {@link CURVE_WIDTH} (x) and tab height (y).
 *
 * `R_SEG` defines the **right** side: (0,0) = tab top-right corner, (1,1) = content level.
 */
export const R_SEG = [
  // Seg 1: nearly flat at tab top — gentle departure
  { c1x: 0.225, c1y: 0, c2x: 0.338, c2y: 0, ex: 0.424, ey: 0.077 },
  // Seg 2: diagonal middle section
  { c1x: 0.500, c1y: 0.145, c2x: 0.562, c2y: 0.253, ex: 0.600, ey: 0.385 },
  // Seg 3: steep then flattening to content level
  { c1x: 0.689, c1y: 0.693, c2x: 0.803, c2y: 1.0, ex: 1.0, ey: 1.0 },
]

/**
 * Normalized S-curve bezier control points for the **left** side of the active tab.
 *
 * @description
 * Mirror of {@link R_SEG}. (0,1) = content level, (1,0) = tab top-left corner.
 * See {@link R_SEG} for coordinate system details.
 */
export const L_SEG = [
  // Seg 1: departing from content level — gentle start
  { c1x: 0.197, c1y: 1.0, c2x: 0.311, c2y: 0.693, ex: 0.400, ey: 0.385 },
  // Seg 2: diagonal middle section
  { c1x: 0.438, c1y: 0.253, c2x: 0.500, c2y: 0.145, ex: 0.576, ey: 0.077 },
  // Seg 3: nearly flat arriving at tab top — gentle arrival
  { c1x: 0.662, c1y: 0, c2x: 0.775, c2y: 0, ex: 1.0, ey: 0 },
]
